import { reduxForm } from 'redux-form';
import { connect } from 'react-redux'

import { editPassword } from '../../actions/settings_actions';
import UserPassword from '../../components/Settings/userPassword';

function mapStateToProps(state) {
  return {
    editUserDetailSuccess: state.settings.editUserDetailSuccess,
    editPasswordIsLoading: state.settings.editPasswordIsLoading,
    initialValues: state.auth,
    editPasswordError: state.settings.editPasswordError,
  }
}

const userPassword = reduxForm({
  form: 'userPassword'
})(UserPassword);

export default connect(mapStateToProps, { editPassword })(userPassword)



// WEBPACK FOOTER //
// ./master/jsx/containers/Auth/userPassword.jsx